/* eslint-disable react/prop-types */
import * as React from 'react';

const H1Icon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M16 10L19 9L19 19M3 5V12M3 12V19M3 12H11M11 5V12M11 12V19'
          />
        </g>
      </g>
    </svg>
  ),
);
H1Icon.displayName = 'H1Icon';

const H2Icon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M15 12.5V12C15 10.3431 16.3431 9 18 9H18.1716C19.7337 9 20.9996 10.2665 20.9996 11.8286C20.9996 12.5788 20.702 13.2982 20.1716 13.8286L15 19.0002L21 19M3 5V12M3 12V19M3 12H11M11 5V12M11 12V19'
          />
        </g>
      </g>
    </svg>
  ),
);
H2Icon.displayName = 'H2Icon';

const H3Icon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M15 9H21L17 13H18C19.6569 13 21 14.3431 21 16C21 17.6569 19.6569 19 18 19C17.3793 19 16.7738 18.8077 16.2671 18.4492C15.7604 18.0907 15.3775 17.5838 15.1709 16.9985M3 5V12M3 12V19M3 12H11M11 5V12M11 12V19'
          />
        </g>
      </g>
    </svg>
  ),
);
H3Icon.displayName = 'H3Icon';

const H4Icon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M18 9L15.5 17H20M20 17H21M20 17V14M20 17V19M3 5V12M3 12V19M3 12H11M11 5V12M11 12V19'
          />
        </g>
      </g>
    </svg>
  ),
);
H4Icon.displayName = 'H4Icon';

const H5Icon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M21 9H17L15.75 14.0158C15.8285 13.9268 15.912 13.8429 16 13.7642C16.3509 13.4504 16.7731 13.2209 17.2346 13.0991C17.9263 12.9166 18.6611 12.9876 19.3053 13.2987C19.9495 13.6099 20.4608 14.1414 20.7479 14.7967C21.035 15.452 21.0788 16.188 20.8707 16.8725C20.6627 17.557 20.2165 18.1447 19.6133 18.5295C19.0101 18.9142 18.2895 19.0704 17.5811 18.9704C16.8726 18.8705 16.2232 18.521 15.75 17.9844M3 5V12M3 12V19M3 12H11M11 5V12M11 12V19'
          />
        </g>
      </g>
    </svg>
  ),
);
H5Icon.displayName = 'H5Icon';

const H6Icon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M15.4024 14.5249C14.574 15.9516 15.0656 17.7759 16.5005 18.5997C17.9354 19.4234 19.7701 18.9346 20.5986 17.5078C21.427 16.0811 20.9352 14.2571 19.5003 13.4334C18.0655 12.6097 16.2309 13.0982 15.4024 14.5249ZM15.4024 14.5249L18.9998 8M3 5V12M3 12V19M3 12H11M11 5V12M11 12V19'
          />
        </g>
      </g>
    </svg>
  ),
);
H6Icon.displayName = 'H6Icon';

const TextIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '13',
      height = '13',
      fill = 'none',
      viewBox = '0 0 26 26',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M12 3V21M9 21H15M19 6V3H5V6'
          />
        </g>
      </g>
    </svg>
  ),
);
TextIcon.displayName = 'TextIcon';

const SubscriptIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '22',
      height = '22',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.7433 5.33104C4.37384 4.92053 3.74155 4.88726 3.33104 5.25671C2.92053 5.62617 2.88726 6.25846 3.25671 6.66897L7.15465 11L3.25671 15.331C2.88726 15.7416 2.92053 16.3738 3.33104 16.7433C3.74155 17.1128 4.37384 17.0795 4.7433 16.669L8.50001 12.4949L12.2567 16.669C12.6262 17.0795 13.2585 17.1128 13.669 16.7433C14.0795 16.3738 14.1128 15.7416 13.7433 15.331L9.84537 11L13.7433 6.66897C14.1128 6.25846 14.0795 5.62617 13.669 5.25671C13.2585 4.88726 12.6262 4.92053 12.2567 5.33104L8.50001 9.50516L4.7433 5.33104ZM17.3181 14.0484C17.6174 13.7595 18.1021 13.7977 18.3524 14.13C18.5536 14.3971 18.5353 14.7698 18.3088 15.0158L15.2643 18.3227C14.9955 18.6147 14.9248 19.0382 15.0842 19.4017C15.2437 19.7652 15.6031 20 16 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H18.2799L19.7802 16.3704C20.6607 15.414 20.7321 13.965 19.95 12.9267C18.9769 11.6348 17.0925 11.4862 15.929 12.6096L15.3054 13.2116C14.9081 13.5953 14.897 14.2283 15.2806 14.6256C15.6642 15.023 16.2973 15.0341 16.6946 14.6505L17.3181 14.0484Z'
      />
    </svg>
  ),
);
SubscriptIcon.displayName = 'SubscriptIcon';

const SuperscriptIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '22',
      height = '22',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.3181 6.04842C17.6174 5.75945 18.1021 5.79767 18.3524 6.12997C18.5536 6.39707 18.5353 6.76978 18.3088 7.01579L15.2643 10.3227C14.9955 10.6147 14.9248 11.0382 15.0842 11.4017C15.2437 11.7652 15.6031 12 16 12H20C20.5523 12 21 11.5523 21 11C21 10.4477 20.5523 10 20 10H18.2799L19.7802 8.37041C20.6607 7.41399 20.7321 5.96504 19.95 4.92665C18.9769 3.63478 17.0925 3.48621 15.929 4.60962L15.3054 5.21165C14.9081 5.59526 14.897 6.22833 15.2806 6.62564C15.6642 7.02296 16.2973 7.03406 16.6946 6.65045L17.3181 6.04842ZM4.7433 8.33104C4.37384 7.92053 3.74155 7.88725 3.33104 8.25671C2.92053 8.62616 2.88726 9.25845 3.25671 9.66896L7.15465 14L3.25671 18.331C2.88726 18.7415 2.92053 19.3738 3.33104 19.7433C3.74155 20.1128 4.37384 20.0795 4.7433 19.669L8.50001 15.4948L12.2567 19.669C12.6262 20.0795 13.2585 20.1128 13.669 19.7433C14.0795 19.3738 14.1128 18.7415 13.7433 18.331L9.84537 14L13.7433 9.66896C14.1128 9.25845 14.0795 8.62616 13.669 8.25671C13.2585 7.88725 12.6262 7.92053 12.2567 8.33104L8.50001 12.5052L4.7433 8.33104Z'
      />
    </svg>
  ),
);
SuperscriptIcon.displayName = 'SuperscriptIcon';

const InlineCodeIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '16',
      height = '16',
      fill = 'none',
      viewBox = '0 0 24 24',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <g strokeWidth='0' />
      <g strokeLinecap='round' strokeLinejoin='round' />
      <g>
        <g>
          <path
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M7 8L3 11.6923L7 16M17 8L21 11.6923L17 16M14 4L10 20'
          />
        </g>
      </g>
    </svg>
  ),
);
InlineCodeIcon.displayName = 'InlineCodeIcon';

const TableIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17 5H1M17 9H1M17 13H1M9 1V17M1.0011 0.999756H17.0016V17.0002H1.0011V0.999756Z'
      />
    </svg>
  ),
);
TableIcon.displayName = 'TableIcon';

const TableInsertIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17 5H1M13 9H1M9 13H1M9 1V12.9926M12.9998 14.9995H16.9998M14.9996 17.0002V13.0003M1 0.999512H17V8.99951H9V16.9995L1 17.0075V0.999512Z'
      />
    </svg>
  ),
);
TableInsertIcon.displayName = 'TableInsertIcon';

const TableRemoveIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17 5H1M13 9H1M9 13H1M9 1V12.9926M12.9998 14.9995H16.9998M1 0.999512H17V8.99951H9V16.9995L1 17.0075V0.999512Z'
      />
    </svg>
  ),
);
TableRemoveIcon.displayName = 'TableRemoveIcon';

const TableHeaderColumnIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        fill='currentColor'
        d='M12.9995 17.0002H17V0.999756H12.9995V17.0002Z'
      />
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M9.00004 16.9999V0.999947M5.00004 16.9999V0.999947M12.9995 17.0002H0.999268V0.999756H12.9995M12.9995 17.0002V0.999756M12.9995 17.0002H17V0.999756H12.9995'
      />
    </svg>
  ),
);
TableHeaderColumnIcon.displayName = 'TableHeaderColumnIcon';

const TableHeaderRowIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        fill='currentColor'
        d='M17.0004 5.00073L17.0005 1.00024H1.00006L1 5.00073H17.0004Z'
      />
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17 9H1.00001M17 13H1.00001M17.0004 5.00073V17.001H1V5.00073M17.0004 5.00073H1M17.0004 5.00073L17.0005 1.00024H1.00006L1 5.00073'
      />
    </svg>
  ),
);
TableHeaderRowIcon.displayName = 'TableHeaderRowIcon';

const TableHeaderCellIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        fill='currentColor'
        d='M8.99943 4.99997H17.0001L16.9996 0.999903L9.00009 0.999969L8.99943 4.99997Z'
      />
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17.0001 4.99997H1.00019M17.0001 4.99997H8.99943L9.00009 0.999969M17.0001 4.99997L16.9996 0.999903L9.00009 0.999969M9.00009 17V0.999969M17.0001 8.99997H1.00019M17.0001 13H1.00009M16.999 17.0005H0.998535V0.99646H16.999V17.0005Z'
      />
    </svg>
  ),
);
TableHeaderCellIcon.displayName = 'TableHeaderCellIcon';

const TableColumnIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.99988 1V17M4.99988 1V17M12.9999 1V17M1.00098 0.999756H17.0014V17.0002H1.00098V0.999756Z'
      />
    </svg>
  ),
);
TableColumnIcon.displayName = 'TableColumnIcon';

const TableColumnRemoveIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M9 1V12.9926M12.9998 14.9995H16.9998M5.005 1V17.0075M13 1V9M1 0.999512H17V8.99951H9V16.9995L1 17.0075V0.999512Z'
      />
    </svg>
  ),
);
TableColumnRemoveIcon.displayName = 'TableColumnRemoveIcon';

const TableColumnInsertBeforeIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M9 1V12.9926M9 1L1 0.999512V16.9995H9V1ZM12.9998 14.9995H16.9998M14.9996 17.0002V13.0003M5 17.0005V1M12.9999 0.999756H16.9999V8.99976H12.9999V0.999756Z'
      />
    </svg>
  ),
);
TableColumnInsertBeforeIcon.displayName = 'TableColumnInsertBeforeIcon';

const TableColumnInsertAfterIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17.0001 1V12.9926M17.0001 1L9.00006 0.999512V16.9995H17.0001V1ZM13.0001 0.999756V16.9998M0.994873 14.9995H4.99486M2.99554 17.0002V13.0003M0.995789 0.999756H4.99577V8.99976H0.995789V0.999756Z'
      />
    </svg>
  ),
);
TableColumnInsertAfterIcon.displayName = 'TableColumnInsertAfterIcon';

const TableRowIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17 5H1.00001M17 9H1.00001M17 13H1.00001M17.0004 1.00122V17.0017H1V1.00122H17.0004Z'
      />
    </svg>
  ),
);
TableRowIcon.displayName = 'TableRowIcon';

const TableRowRemoveIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M0.996155 5.00293H16.9962M0.996155 9.00293H12.9888M0.996155 13.0029H8.99615M16.9971 15.0034H12.9971M0.99585 1.00293V17.0029H8.99585V9.00293H16.9958L17.0038 1.00293H0.99585Z'
      />
    </svg>
  ),
);
TableRowRemoveIcon.displayName = 'TableRowRemoveIcon';

const TableRowInsertBeforeIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.9995 5.00023V1.00024M17.0001 3.00047H13.0001M0.997864 13.2361H16.9979M0.997864 9.23607H12.9905M0.997864 9.23607L0.997559 17.2361H16.9976V9.23607H0.997864ZM0.999756 4.99998V1H8.99976V4.99998H0.999756Z'
      />
    </svg>
  ),
);
TableRowInsertBeforeIcon.displayName = 'TableRowInsertBeforeIcon';

const TableRowInsertAfterIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.9995 17.0002V13.0003M17.0001 15.0005H13.0001M1.0058 5H17.0058M1.0058 1H12.9984M1.0058 1L1.00543 9H17.0054V1H1.0058ZM0.999756 17.0002V13.0003H8.99976V17.0002H0.999756Z'
      />
    </svg>
  ),
);
TableRowInsertAfterIcon.displayName = 'TableRowInsertAfterIcon';

const TableCellMergeIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.99988 1V4.00003M8.99988 7.5V10.5M8.99988 14V17M12.9999 1V17M4.99988 1V17M1.00098 0.999756H17.0014V17.0002H1.00098V0.999756Z'
      />
    </svg>
  ),
);
TableCellMergeIcon.displayName = 'TableCellMergeIcon';

const TableCellSplitIcon = React.forwardRef<
  React.ElementRef<'svg'>,
  React.ComponentPropsWithoutRef<'svg'>
>(
  (
    {
      width = '15',
      height = '15',
      fill = 'none',
      viewBox = '0 0 18 18',
      xmlns = 'http://www.w3.org/2000/svg',
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      fill={fill}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.99994 1V4.00003M8.99994 7.5V10.5M8.99994 14V17M1 0.999756H5.0001V17.0002H1V0.999756ZM13 0.999756H17.0001V17.0002H13V0.999756Z'
      />
    </svg>
  ),
);
TableCellSplitIcon.displayName = 'TableCellSplitIcon';

export {
  H1Icon,
  H2Icon,
  H3Icon,
  H4Icon,
  H5Icon,
  H6Icon,
  InlineCodeIcon,
  SubscriptIcon,
  SuperscriptIcon,
  TableCellMergeIcon,
  TableCellSplitIcon,
  TableColumnIcon,
  TableColumnInsertAfterIcon,
  TableColumnInsertBeforeIcon,
  TableColumnRemoveIcon,
  TableHeaderCellIcon,
  TableHeaderColumnIcon,
  TableHeaderRowIcon,
  TableIcon,
  TableInsertIcon,
  TableRemoveIcon,
  TableRowIcon,
  TableRowInsertAfterIcon,
  TableRowInsertBeforeIcon,
  TableRowRemoveIcon,
  TextIcon,
};
